import React, { FC } from "react"
import { AudioPlayer } from "./AudioPlayer"
import { useDocumentAsMarkdown } from "@/hooks/useDocumentAsMarkdown"
import { Skeleton } from "@/components/ui/skeleton" // For loading state
import ReactMarkdown from "react-markdown" // Import react-markdown

interface AudioViewerProps {
	url: string
	fileName: string
	caseId: string
	documentId: string
}

export const AudioViewer: FC<AudioViewerProps> = ({
	url,
	fileName,
	caseId,
	documentId,
}) => {
	const {
		data: markdownData,
		isLoading: isLoadingMarkdown,
		error: markdownError,
	} = useDocumentAsMarkdown(caseId, documentId)

	const transcript = markdownData

	return (
		<div className="flex flex-col h-full">
			{/* Audio Player */}
			<div className="p-4 border-b">
				<AudioPlayer url={url} fileName={fileName} />
			</div>

			{/* Transcript Section */}
			<div className="flex-grow p-4 overflow-auto">
				{isLoadingMarkdown && (
					<div className="space-y-2">
						<Skeleton className="h-4 w-full" />
						<Skeleton className="h-4 w-full" />
						<Skeleton className="h-4 w-3/4" />
					</div>
				)}
				{markdownError && (
					<p className="text-red-500">
						Error loading transcript: {markdownError.message}
					</p>
				)}
				{!isLoadingMarkdown && !markdownError && transcript && (
					<div className="prose prose-sm max-w-none">
						<ReactMarkdown>{transcript}</ReactMarkdown>
					</div>
				)}
				{!isLoadingMarkdown && !markdownError && !transcript && (
					<p className="text-muted-foreground">Transcript not yet available.</p>
				)}
			</div>
		</div>
	)
}
